<div class="hrv">

  <!-- Header -->
  <div class="hrv__header">
    <div class="hrv__icon-wrap">
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 
                 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 
                 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 
                 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
          fill="white"/>
      </svg>
    </div>
    <div class="hrv__header-text">
      <h2 class="hrv__title">Holiday</h2>
      <p class="hrv__date">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
             style="margin-right:5px; vertical-align:middle;">
          <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.89 4 3 4.9 3 
                   6v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 
                   2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"
            fill="#6b7280"/>
        </svg>
        {{ data.dateLabel }}
      </p>
    </div>
    <button class="hrv__close-btn" type="button" (click)="close()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 
                 10.59 12 5 17.59 6.41 19 12 13.41 17.59 
                 19 19 17.59 13.41 12z" fill="#9ca3af"/>
      </svg>
    </button>
  </div>

  <div class="hrv__divider"></div>

  <!-- Body -->
  <div class="hrv__body">
    <div class="hrv__reason-card">
      <p class="hrv__label">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
             style="margin-right:5px; vertical-align:middle;">
          <path d="M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 
                   8h-4l-1-2H7V6h5l1 2h5v6z" fill="#6366f1"/>
        </svg>
        REASON
      </p>
      <p class="hrv__reason">
        {{ (data.reason || '').trim() ? data.reason : '—' }}
      </p>
    </div>
  </div>

  <!-- Footer -->
  <div class="hrv__actions">
    <button class="hrv__btn-cancel" type="button" (click)="close()">
      Cancel
    </button>
    <button class="hrv__btn-ok" type="button" (click)="close()">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
           style="margin-right:5px;">
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
          fill="white"/>
      </svg>
      Got it
    </button>
  </div>

</div>